import { render, staticRenderFns } from "./UploadPromotionModal.vue?vue&type=template&id=1000298e&scoped=true&"
import script from "./UploadPromotionModal.vue?vue&type=script&lang=js&"
export * from "./UploadPromotionModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadPromotionModal.vue?vue&type=style&index=0&id=1000298e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1000298e",
  null
  
)

export default component.exports